// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["mce-styles","editor-styles","styles"], () => (__webpack_require__("./assets/js/scripts.js")))
__webpack_require__.O(undefined, ["mce-styles","editor-styles","styles"], () => (__webpack_require__("./assets/css/styles.scss")))
__webpack_require__.O(undefined, ["mce-styles","editor-styles","styles"], () => (__webpack_require__("./assets/css/editor-styles.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["mce-styles","editor-styles","styles"], () => (__webpack_require__("./assets/css/mce-styles.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
